/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.TransactionTypesResponse | undefined,
  (requestParams: vp.TransactionTypesRequst) => void,
  () => void,
];

function useFetchTransactionTypes({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.TransactionTypesRequst>();
  const [response, setResponse] = useState<vp.TransactionTypesResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.TransactionTypesRequst, cancelTokenSource: CancelTokenSource) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const { CountriesID, ...filteredParams } = requestParams;
      const res = await api.fetchTransactionTypes(filteredParams, cancelTokenSource);
      if (CountriesID) {
        res.TransactionTypes = res.TransactionTypes.filter(
          (type) => type.ADRCountries_ID === String(CountriesID) || type.ADRCountries_ID === null,
        );
      }
      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.TransactionTypesRequst) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchTransactionTypes);
